export const customData = [
  // status
  {
    category: "status",
    legend: "Статус",
    data: [
      {
        label: "Загубили",
        value: "LOST"
      },
      {
        label: "Шукають власників",
        value: "FOUND"
      }
    ]
  },

  // type_of_animal
  {
    category: "type",
    legend: "Тип тварини",
    inputType: "",
    data: [
      {
        label: "Собаки",
        value: "DOG"
      },
      {
        label: "Коти",
        value: "CAT"
      },
      {
        label: "Інші",
        value: "OTHER"
      }
    ]
  },

  // gender
  {
    category: "gender",
    legend: "Стать",
    data: [
      {
        label: "Хлопчик",
        value: "MALE"
      },
      {
        label: "Дівчинка",
        value: "FEMALE"
      },
      {
        label: "Не визначено",
        value: "UNKNOWN"
      }
    ]
  },

  // color
  {
    category: "color",
    legend: "Колір",
    inputType: "checkbox",
    data: [
      {
        label: "Чорний",
        value: "Чорний"
      },
      {
        label: "Білий",
        value: "Білий"
      },
      {
        label: "Сірий",
        value: "Сірий"
      },
      {
        label: "Бежевий",
        value: "Бежевий"
      },
      {
        label: "Коричневий",
        value: "Коричневий"
      },
      {
        label: "Рудий",
        value: "Рудий"
      },
      {
        label: "Різнокольоровий",
        value: "Різнокольоровий"
      },
      {
        label: "Інший",
        value: ""
      }
    ]
  },

  // size
  {
    category: "size",
    legend: "Розмір",
    inputType: "checkbox",
    data: [
      {
        label: "Маленька",
        value: "SMALL"
      },
      {
        label: "Середня",
        value: "MEDIUM"
      },
      {
        label: "Велика ",
        value: "LARGE"
      }
    ]
  },

  // age
  {
    category: "age",
    legend: "Вік",
    inputType: "checkbox",
    data: [
      {
        label: "0-1 ",
        value: "_0_1"
      },
      {
        label: "1-3 ",
        value: "_1_3"
      },
      {
        label: "4-6 ",
        value: "_4_6"
      },
      {
        label: "6-10 ",
        value: "_6_10"
      },
      {
        label: "Більше 10 ",
        value: "ABOVE_10"
      }
    ]
  },

  // diseases
  {
    category: "diseases",
    legend: "Хвороби",
    data: [
      {
        label: "Так",
        value: "YES"
      },
      {
        label: "Ні",
        value: "NO"
      }
    ]
  },

  // vaccine
  {
    category: "vaccine",
    legend: "Щеплення",
    data: [
      {
        label: "Так",
        value: "YES"
      },
      {
        label: "Ні",
        value: "NO"
      }
    ]
  },

  // sterilization
  {
    category: "sterilization",
    legend: "Стерилізація",
    data: [
      {
        label: "Так",
        value: "YES"
      },
      {
        label: "Ні",
        value: "NO"
      }
    ]
  }
];
